import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      circle: 'fill-grey-30/50',
      circleInactive: 'group-hover:fill-grey-30/90',
      icon: '',
      wrapper: 'bottom-0 m-2 <lg:mr-4'
    }
  }
} satisfies RecursivePartial<VfConfig['video']>
